import React, { useContext, useEffect, useMemo, useState, useCallback, useRef } from "react";
import Screen from '../components/Screen';
import { calculateHoursUntil, formatDate, i18nValue } from '../functions';
import { UserContext } from "../context/user";
import { useParams } from 'react-router';
import { CheckInContext } from "../context/checkin";
import { HotelContext } from "../context/hotel";
import { T, TF } from "react-translator-component";

import useCheckInActions from "../hooks/useCheckInActions";
import { isHostzBlackSummit, isHostzSwissstay, getBlackSummitDepositAmount } from "../components/CheckIn/hotelConditions";

import useSmartDebugLog from "../hooks/useSmartDebugLog";
import { PaymentCart } from "../components/PaymentCart";
import Reservation from "../components/Reservation";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';

export const PaymentScreenNew = () => {
  // useSmartDebugLog("PaymentScreenNew");

  const { id } = useParams();
  const { language } = useContext(UserContext)
  const { data: checkIn, getBalancePaymentUrl } = useContext(CheckInContext);
  const { data: hotel } = useContext(HotelContext);
  const { getAccount } = useCheckInActions();


  console.log('31ene params', id);

  const [loading, setLoading] = useState(true);
  const [account, setAccount] = useState(null);
  const [cart, setCart] = useState(null);
  const [allRequireds, setAllRequireds] = useState(true);
  const [showGoToDash, setShowGoToDash] = useState(true);

  // const [balance, setBalance] = useState(null);
  const [isPaidDepositGaarantee, setIsPaidDepositGaarantee] = useState(false);

  const [paymentState, setPaymentState] = useState('initial');

  useEffect(() => {
    // Voy a buscar el balance
    // getBalance(hotel?.id, checkIn?.id).then(res => {
    getAccount(hotel?.id, checkIn?.id).then(res => {
      console.log('PAYMENTS - getAccount', res);
      setAccount(res);
      setIsPaidDepositGaarantee(res?.depositGuarantee?.paid)
      setLoading(false);
    });
  }, []);


  // useEffect(() => {

  //   console.log('31ene cart', cart);
  //   let totalAmount = 0;

  //   if (cart && balanceDetail) {
  //     console.log('PAYMENT - 000: setTotalCart -> Sólo Depósito de Garantía 1111', totalCart);
  //     if (!totalCart.onlyDepositGuarantee) {
  //       totalAmount = balanceDetail
  //         .filter(item => cart.includes(item.id) && item.id !== "GuaranteeDeposit") // Filtrar por IDs en `selectedIds`
  //         .reduce((sum, item) => sum + item.amount, 0);
  //     } else {
  //       totalAmount = 500;
  //     }
  //   }
  //   // if (cart && balanceDetail) {
  //   //   totalAmount = balanceDetail
  //   //     .filter(item => cart.includes(item.id) && item.id !== "GuaranteeDeposit") // Filtrar por IDs en `selectedIds`
  //   //     .reduce((sum, item) => sum + item.amount, 0);
  //   // }

  //   const _amounts = {
  //     security_deposit: {
  //       value: 0,
  //       currency: paymentCurrency
  //     },
  //     webcheckin: {
  //       value: totalAmount * 100,
  //       currency: paymentCurrency
  //     },
  //     add_ons: {
  //       value: 0,
  //       currency: paymentCurrency
  //     }
  //   }

  //   setTotalCart({ ...totalCart, amount: 100 * totalAmount, amounts: _amounts });
  // }, [cart]);


  useEffect(() => {

    let onlyDepositGuarantee = false;

    if (account?.balance?.charges) {

      let arrayWithIds = (Object.entries(account.balance.charges) || [])
        // .filter(([key, value]) => value.amount > 0)
        .map(([key, value]) => ({
          ...value,
          id: key,
          required: allRequireds,
          selected: true
        }));

      let arrayPayments = [];
      // Solo muestro los pagos si existen items a mostrar en el carro
      if (arrayWithIds.length > 0) {
        arrayPayments = (Object.entries(account.balance.payments) || [])
          .map(([key, value]) => ({
            ...value,
            id: key,
            name: T('payments.older'),
            desc: formatDate(value.date, true),
            amount: -1 * (value.amount),
            required: true,
            selected: true,
            isPayment: true
          }));

        if (arrayPayments) {
          arrayWithIds = [...arrayWithIds, ...arrayPayments];
          // arrayWithIds = (Object.assign(arrayWithIds, arrayPayments)).sort((a, b) => (a.isPayment ? 1 : -1));
        }
      }

      console.log('000000', arrayWithIds);

      if (id?.toLowerCase() === "b") {

        // SIN DEPÓSITO DE GARANTÍA

      } else {

        if (id?.toLowerCase() === "sd") {
          // Sólo se quiere pagar el deposito de garantía
          arrayWithIds = [];
        }

        if (account.depositGuarantee?.show && !account.depositGuarantee?.paid) {
          if (arrayWithIds.length == 0) {
            onlyDepositGuarantee = true;
          }
          arrayWithIds.unshift(
            {
              amount: account.depositGuarantee?.amount || 500,
              id: "GuaranteeDeposit",
              name: T("payments.guarantee-deposit"),
              qty: 1,
              desc: T("payments.guarantee-deposit-desc"),
              required: account.depositGuarantee?.required || false,
              selected: true,
              isSecurityDeposit: true
            }
          );
        }

      }

      setCart(arrayWithIds);
    }
  }, [account])

  const { showGuaranteeDeposit, showOptionNoPayment, noShowItemInCart, more72hs } = useMemo(() => {
    if (!checkIn.reservation) return { noShowItemInCart: [], showGuaranteeDeposit: false, showOptionNoPayment: false, more72hs: false };

    let noShowItemInCart = [];
    let showGD = true;
    let showOmmit = false;
    let isMore72hs = false;

    console.log('PAYMENT - checkin', checkIn);

    const hours = calculateHoursUntil(checkIn.reservation.arrival);
    console.log('PAYMENT - hours to arrive', hours);
    if (hours >= 72) {
      // Faltan más de 72 horas, no muestro garantía y permito continuar
      showGD = false;
      showOmmit = true;
      isMore72hs = true;
    }

    // Criterios por channel
    if (!checkIn.channel?.toLowerCase().includes('direct')) {
      noShowItemInCart = ['Accommodation'];
    }
    if (checkIn.channel?.toLowerCase().includes('airbnb')) {
      showGD = false;
    }
    if (hotel.id === "9983de2a-9f3e-4c75-9fb9-62e9855681e8") {
      showGD = false;
    }

    return { noShowItemInCart: noShowItemInCart, showGuaranteeDeposit: showGD, showOptionNoPayment: showOmmit, more72hs: isMore72hs };

  }, [checkIn?.reservation]);

  const paymentCurrency = useMemo(() => {
    if (checkIn?.balance?.currency) {
      return checkIn.balance.currency
    }
    return "CHF"
  }, [checkIn]);

  // const paymentResult = (res, detail) => {
  //   console.log('paymentResult - res', res);
  //   console.log('paymentResult - detail', detail);

  //   if (res == 'Loading') {
  //     console.log('setPaymentState', 'loading-component');
  //     setPaymentState('loading-component');
  //   }
  //   if (res == 'InProgress') {
  //     console.log('setPaymentState', 'in-progress');
  //     setPaymentState('in-progress');
  //   }
  //   if (res == 'Authorised') {
  //     console.log('setPaymentState', 'done');
  //     setPaymentState('done');
  //   }
  //   if (res == 'Refused' || res == 'Error') {
  //     console.log('setPaymentState', 'error');
  //     setPaymentState('error');
  //   }

  // }

  const handleChangePaymentState = (state) => {
    if (state == "done") {
      setPaymentState("done");
    }
  }

  if (loading) {
    return <Screen
      backUrl={`./checkin/status`}
      section={`payment`}
      title={T("general.payments")}
    >
      {loading && (
        <div className="loading text-center mt-5 p-10">
          <div className="spinner-border" role="status"></div>
        </div>
      )}
      {/* {!loading && (
        // <p className="text-center p-4 mt-4">{T('payments.guarantee-deposit-paid')}</p>
        <p className="text-center p-4 mt-4">{T('payments.balance-paid')}</p>
      )} */}
    </Screen>
  }

  return (
    <Screen
      section={`payment`}
      title={T("general.payments")}
      showBackButton={false}
    >
      {/* {id === "balance" && <p>Pago de Saldo<br />999 EUR</p>} */}

      {/* <button onClick={handlePayButtonClick}>Pay</button> */}

      <div className="mb-2">
        <Reservation
          showPrice={false}
          onlyInfo={true}
          showRowInfo={!isHostzSwissstay(hotel.id)} />
      </div>

      {paymentState == "initial" && (
        <>
          {showGuaranteeDeposit && isHostzBlackSummit(hotel.id) && (
            <p className="pt-2 mb-4 text-muted general-text-sm text-center" style={{ lineHeight: 1.25 }}>
              {T("payments.msg_guarantee")}
            </p>
          )}

          {more72hs && isHostzBlackSummit(hotel.id) && (
            <p className="pt-2 mb-4 text-muted general-text-sm text-center" style={{ lineHeight: 1.25 }}>
              {TF("payments.msg_guarantee_72hs", [getBlackSummitDepositAmount(hotel.id, checkIn)])}
            </p>
          )}
        </>
      )}

      <div>
        <PaymentCart
          checkIn={checkIn}
          language={language}
          currency={paymentCurrency}
          data={cart}
          onChangeState={handleChangePaymentState}
          config={{
            optionPayLater: false
          }}
        />
      </div>

      {paymentState == "done" && (
        <div>
          <NavLink className="btn btn-block btn-secondary mt-4 mb-2 text-white" to={{ pathname: '/' + hotel.code + '/checkin/status' }} replace>
            {T('services.go-to-requests')}
          </NavLink>
        </div>
      )}

    </Screen>
  );
}

export default PaymentScreenNew;